import { color } from '#components/mobile/ui/tokens';

import type { Tripulante } from './tripulacionLogica';

/** La inicial de quien apuntó el movimiento: verde tú, azul tu pareja. */
export function InicialAutor({
  tripulante,
  size = 18,
}: {
  tripulante: Tripulante;
  size?: number;
}) {
  return (
    <span
      data-testid="inicial-autor"
      title={tripulante.nombre}
      aria-label={tripulante.nombre}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        fontSize: size * (tripulante.inicial.length > 1 ? 0.45 : 0.56),
        fontWeight: 800,
        lineHeight: 1,
        color: '#fff',
        backgroundColor: tripulante.esYo ? color.ok : color.accent,
        boxShadow: `0 0 0 2px ${color.surface}`,
      }}
    >
      {tripulante.inicial}
    </span>
  );
}
